import { Box, Divider, Stack, Typography, useTheme } from '@mui/material';

import { PortalTheme, StampCard } from '@frontend-libs/portal';

import { StampCardListModel } from '@portal-clients/stamp-card';

import { useLocale } from '@frontend/hooks';
import { tApp } from '@frontend/locales';

export interface StampCardDrawerContentProps {
  stampCard: StampCardListModel;
}

export const StampCardDrawerContent = ({
  stampCard,
}: StampCardDrawerContentProps) => {
  const theme = useTheme<PortalTheme>();
  const { formatters } = useLocale();
  return (
    <Stack>
      <Stack
        spacing={2}
        alignItems="center"
        direction="column"
        sx={{
          paddingBottom: 3,
          backgroundColor: theme.palette.background.highlight,
        }}
        padding={2}
      >
        <Box
          sx={{
            width: '320px',
          }}
        >
          <StampCard
            key={stampCard.id}
            title={stampCard.title}
            currentStamps={stampCard.currentStamps}
            maxStamps={stampCard.maxStamps}
          />
        </Box>
      </Stack>
      <Stack
        spacing={1}
        alignContent="start"
        direction="column"
        paddingTop={3}
        padding={2}
      >
        <Typography variant="body1" color="textSecondary" sx={{ pb: 1 }}>
          {stampCard.description}
        </Typography>
        <Divider />

        <Typography
          variant="subtitle3"
          color="textSecondary"
          component="a"
          pt={1}
        >
          {stampCard.scopes && stampCard.scopes.length > 0
            ? tApp.vouchers.validAt({
                validAt: stampCard.scopes
                  .map(
                    (scope) =>
                      `${scope?.siteUnit?.displayName}${scope?.businessUnits?.length ? `: ${scope?.businessUnits.map((businessUnit) => businessUnit.displayName).join(', ')}` : ''}`,
                  )
                  .join(', '),
              })
            : tApp.vouchers.validAt({
                validAt: tApp.vouchers.allSites(),
              })}
        </Typography>
        <Typography variant="subtitle4" color="textSecondary">
          {stampCard.validityPeriod?.to
            ? tApp.stampCards.validUntil({
                validUntil: formatters.relativeDatetime(
                  new Date(stampCard.validityPeriod.to!),
                ),
                interpolation: { escapeValue: false },
              })
            : tApp.stampCards.noExpirationDate()}
        </Typography>
      </Stack>
    </Stack>
  );
};
